import React from 'react';
import { Link } from 'react-router';
import { string, bool } from 'prop-types';
import cx from 'classnames';

import IconOk from 'icons/panel-segment.inline.svg';
import IconDisconnected from 'icons/panel-segment-broken.inline.svg';
import IconPanelSwitch from 'icons/panel-switch.inline.svg';
import segmentStatus from 'propTypes/segmentStatus';
import styles from './SegmentHeader.scss';

export default function SegmentHeader({ fromName, toName, status, oppositeSegmentId, isLoading }) {
  return (
    <div
      className={cx(styles.main, {
        [styles.isLoading]: isLoading,
      })}
    >
      <header className={styles.header}>
        <h1 className={styles.title}>Segment</h1>
      </header>

      <div className={styles.content}>
        <div className={styles.icon}>
          {status !== 'disconnected' ? <IconOk height={72} /> : <IconDisconnected height={72} />}
        </div>
        <h2 className={styles.text}>
          <div className={styles.textGroup}>
            <div className={styles.label}>from</div>
            <div className={styles.name}>
              {fromName}
            </div>
          </div>
          <div className={styles.textGroup}>
            <div className={styles.label}>to</div>
            <div className={styles.name}>
              {toName}
            </div>
          </div>
        </h2>

        {oppositeSegmentId &&
          <div className={styles.switchButtonWrapper}>
            <Link to={`/map/live/segments/${oppositeSegmentId}`} className={styles.switchButton}>
              <IconPanelSwitch className={styles.switchButtonIcon} style={{ width: '1.5em' }} />
            </Link>
          </div>}
      </div>
    </div>
  );
}

SegmentHeader.propTypes = {
  fromName: string.isRequired,
  toName: string.isRequired,
  status: segmentStatus.isRequired,
  oppositeSegmentId: string,
  isLoading: bool,
};



// WEBPACK FOOTER //
// ./src/components/DataPanel/Details/SegmentHeader/index.js